// extracted by mini-css-extract-plugin
export default {"link":"Privacy_link__OPOlc","modalOverlay":"Privacy_modalOverlay__dB0oV","modalContent":"Privacy_modalContent__VTr3I","closeButton":"Privacy_closeButton__8l2OK"};